import { CatalogStatusesEnum } from '../enums/CatalogStatusesEnum';
import { CommonCatalogsNamesEnum } from '../enums/CommonCatalogsNamesEnum';
import { ComplexCatalogsNamesEnum } from '../enums/ComplexCatalogsNamesEnum';
import { ICatalogsState } from '../interfaces/ICatalogsState';

export const initialCatalogsState: ICatalogsState = {
  [CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_REASONS_CANCELED]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ROLES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  // ToDo: replace to LK
  [CommonCatalogsNamesEnum.KNM_INSPECTORS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_LINK_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_NOTICE_METHODS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_OBJECT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.LIST_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [ComplexCatalogsNamesEnum.KNM_REASON_TYPES]: {},
  [ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES]: {},
  [ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES]: {},
  [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {},
  [ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES]: {},
  [CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE]: {},
  [ComplexCatalogsNamesEnum.KNM_TYPES_248]: {},
  [CommonCatalogsNamesEnum.KNM_TYPES_CANCELED]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_TYPES_294]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_STATUSES_248]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_STATUSES_294]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PM_STATUSES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.DECISION_STATUSES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_TYPES_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_KINDS_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_YEARS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.RISK_CATEGORIES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_PLAN_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.USER_KNOS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.USER_PROSECUTORS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.FEDERAL_LAWS_248]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.FEDERAL_LAWS_294]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.SUPERVISION_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.REGISTER_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.MSP_CATEGORIES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.TERRITORIAL_UNITS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_ACT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_CANCELED_REASONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.COUNTRIES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.GENERIC_REASONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.MANDATORY_CATEGORIES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PM_FORMS_CONDUCTING]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_KINDS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_COURTS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.DISTRICTS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.INTERACTION_CATEGORIES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PM_CANCELED_REASONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.VIOLATION_MATERIAL_TYPE]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.VIOLATION_FIX_METHOD]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.VIOLATION_FIX_GRADE]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS]: {},
  [ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES]: {},
  [CommonCatalogsNamesEnum.KNO_LEVELS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_REMARKS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.KNM_REMARKS_ALL]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.ERVK_ORDERS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.TERMINATION_REASONS]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
  [CommonCatalogsNamesEnum.UAV_TYPES]: {
    data: [],
    status: CatalogStatusesEnum.IDLE,
  },
};
